<template>
    <div>
        <h3 class="form-heading">Website Details</h3>
        <txt label="Site Name" v-model="model.site_name"></txt>
        <div class="form-group">
            <label for="domain" class="control-label">
                Live Domain <small v-if="isWHM && model.is_live">(Active)</small>
            </label>
            <input id="domain" name="domain" type="text" class="form-control" v-model="model.domain">
        </div>
        <div class="form-group">
            <label for="dev_domain" class="control-label">
                Dev Domain <small v-if="isWHM && !model.is_live">(Active)</small>
            </label>
            <div v-if="model.app_id!='wix'" class="input-group">
                <input type="text" class="form-control" id="dev_domain" v-model="model.dev_domain">
                <span class="input-group-addon">{{ demoDomain }}</span>
            </div>
            <!-- different dev URL format for Wix -->
            <div v-if="model.app_id=='wix'" class="input-group">
                <span class="input-group-addon" style="padding:0px!important;">{{ demoDomain }}</span> <!-- {{model.demo_domain}} -->
                <input type="text" class="form-control" id="dev_domain" v-model="model.dev_domain">
            </div>
        </div>

        <button class="btn btn-default" type="button" @click="showModal" v-if="isWHM">
            Activate <span v-if="model.is_live">Dev</span><span v-if="!model.is_live">Live</span> Domain
        </button>

        <div class="buttons pull-right">
            <button class="btn btn-success" @click="store">
                <i class="icon icon-save"></i> {{ trans('save') }}
            </button>
        </div>

        <div v-if="typeof model.info !== 'undefined' && model.info !== ''" >
            <h3 class="form-heading">Admin Actions</h3>
            <div v-html="model.info"></div>
        </div>

        <h3 class="form-heading">Additional Info</h3>
        <div class="form-group">
            <label class="control-label">Company</label>
            <company name="Website" v-model="model.company"></company>
        </div>

        <div class="form-group">
            <label class="control-label">Server</label>
            <list v-if="account_id === 2" id="server_id" label="Web Server" :list='servers' :value="model.server_id" v-model="model.server_id" :usekey="true"></list>
            <input v-if="account_id !== 2" readonly type="text" :value="model.server" class="form-control" />
        </div>

        <div v-if="isWHM">
        <h3 class="form-heading">CMS Access <small>These details will not update if you manually change the password.</small></h3>

        <div class="split-fields">
            <txt label="Username" v-model="model.username"></txt>
            <txt label="CMS Password" v-model="model.password"></txt>
        </div>

        <a :href="model.admin_url" target="_blank" class="btn btn-primary">Log In</a>
        </div>

        <div class="website-remote-tools" v-if="isWHM && model.app_id == 'wordpress'" style="padding-top: 10px;">
            <h3 class="form-heading">WordPress Tools</h3>
            <a @click.prevent="createWPR" class="btn btn-primary" target="_blank" v-if="model.wpr_id == 0">
                <span v-if="wprProcessing">processing</span>
                <span v-else>Add to WP Remote</span>
            </a>
            <a @click.prevent="openWPR" class="btn btn-primary" target="_blank" v-if="model.wpr_id != 0">
                <span>Open in WP Remote</span>
            </a>
            <a @click.prevent="resetApiKey" class="btn btn-primary" target="_blank" v-if="model.wpr_id != 0">
                <span v-if="wprProcessing">processing</span>
                <span v-else>Reset API Key</span>
            </a>
        </div>

        <div class="website-remote-tools" v-if="isWPE" style="padding-top: 10px; padding-bottom: 10px">
            <h3 class="form-heading">WordPress Tools</h3>

            <a class="btn btn-primary"  @click.prevent="doAction('createBackup')">Create Backup</a>

            <a :href="'https://developers.google.com/speed/pagespeed/insights/?url=https%3A%2F%2F' + model.domain" target="_blank" class="btn btn-primary">
                View Speed insights
            </a>

            <a @click.prevent="doAction('pagespeedScripts')" class="btn btn-primary">
                Install Speed Tools
            </a>

            <a @click.prevent="doAction('sendPagespeedEmail')" class="btn btn-primary">
                Email about Speed
            </a>
        </div>

        <div v-if="isWHM">
            <h3 class="form-heading">Dev Access</h3>
            <!-- Buttons need to have href = /website/{id}/cpanel-whatever  -->

            <a @click.prevent="doAction('fixAutoLogin')" class="btn btn-primary" target="_blank">
                Fix Auto Login (1.5-3.0)
            </a>

            <a @click.prevent="enableSSL" class="btn btn-primary" target="_blank">
                <span v-if="enablingSSL">processing</span>
                <span v-else>Enable AutoSSL</span>
            </a>
            <a @click.prevent="changeHttp" class="btn btn-primary" target="_blank">
                <span v-if="enablingHttps">processing</span>
                <span v-else>Http => Https</span>
            </a>
            <a :href="href('/cpanel-login')" class="btn btn-primary" target="_blank">{{ trans('cPanel') }}</a>
            <a :href="href('/cpanel-login?app=ftp')" class="btn btn-primary" target="_blank">{{ trans('Manage FTP Accounts') }}</a>

            <a @click="doAction('initWebsiteMigration')" class="btn btn-primary" >Migrate to WPE</a>

            <a @click="doAction('initAWSMigration')" class="btn btn-secondary" >AWS Migration</a>

            <!--<a :href="href('/cpanel-login?app=Database_MySQL')" class="btn btn-primary" target="_blank">{{ trans('manage_databases') }}</a>-->
            <a :href="href('/cpanel-login?app=Database_phpMyAdmin')" class="btn btn-primary" target="_blank">{{ trans('phpmyadmin') }}</a>
        </div>

        <div>
            <h3 class="form-heading">{{ trans('FTP Account') }}</h3>
            <a class="btn btn-primary" v-on:click="addFtp(model.public_id)">{{ trans('create_new') }}</a>
            <br /><br />

            <!-- Where do ftp_list come from? -->
            <ul class="ftp-list" v-if="myisEmpty(ftp_list)">
                <li v-for="ftp in ftp_list">
                    {{ ftp['user'] }} &nbsp;<a v-on:click="editFtp(ftp['user'])" class="btn btn-xs btn-default"><i class="icon icon-edit"></i> {{ trans('edit') }}</a>
                </li>
            </ul>
            <div class="alert alert-danger" v-if="ftp_list_error.length !== 0">{{ ftp_list_error }}</div>
            <br />
        </div>

        <div v-if="isWHM || isWPE ">
            <!-- <button class="btn btn-danger" @click="suspend">Create Task to Suspend Website</button> -->
            <button v-if="this.model.isSuspended" class="btn btn-danger" @click="unsuspend">UnSuspend Website</button>
            <button v-else class="btn btn-danger" @click="suspend" >Suspend Website</button>
            <button class="btn btn-danger" @click="deleteTask">Create Task to Delete Website</button>

        </div>

        <div id="request_domain" class="modal fade" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="row" style="margin-bottom: 10px;">
                        <div class="panel-heading">
                            <h1>Active Domain Change Confirmation</h1>
                        </div>
                    </div>

                    <p>Before changing your active domain, it is important you follow the steps below.</p>

                    <h3>Activating a Live Domain</h3>
                    <p>Ensure you point your domain's name servers to:</p>
                    <ul style="list-style:none;">
                        <li>ns1.maek.it</li>
                        <li>ns2.maek.it</li>
                    </ul>
                    <p>Alternatively you can set the A record of your domain to:
                        <strong>202.60.67.27</strong></p>

                    <p>Also, it is important you modify your site's config files where appropriate to reflect your new domain.</p>

                    <h3>Activating a Dev Domain</h3>
                    <p>Since you're use our maekit.site domain in this instance, you won't need to worry about your nameservers. Just modify your site's config files where appropriate to reflect your new domain.</p>
                    <p>If you mess it up, don't worry, just switch your domain back.</p>
                    <br />
                    <!--<button class="btn btn-default" click="closeModal"><i class="icon icon-cancel"></i> {{ trans('cancel') }}</button>-->
                    <button type="button" class="btn btn-default" @click="toggleLive">Confirm Change</button>
                </div><!-- End of div modal-content -->
            </div><!-- End of div modal-dialog -->
        </div><!-- End of div qcModal -->
    </div>
</template>
<script>
    export default {
        props: {
            name: { default: '' },
        },
        data() {
            return {
                ftp_list_error: '',
                account_id: window.ACCOUNT_ID,
                wprProcessing: false,
                nonce: false,
                enablingSSL: false,
                enablingHttps: false,
                model: {
                    public_id: 0,
                    site_name: '',
                    wpr_id: 0,
                    company: '',
                    is_live: 0,
                    domain: '',
                    app_id: '',
                    server: '',
                    server_id: '',
                    hosted_server: '',
                    dev_domain: '',
                    username: '',
                    password: '',
                    cms_password: '',
                    admin_url: '',
                    info: '',
                    isSuspended: ''
                },
                demo_domain: window.DEMO_DOMAIN,
                ftp_list: {},
            }
        },
        created() {
            this.$eventHub.$on('websiteAction', this.doAction);
            this.$eventHub.$on('websiteSubmit', this.store);
            this.$eventHub.$on('setWebsite', this.setWebsite);
        
        },

        computed: {
            demoDomain() {
                if (this.model.hosted_server === 'shopify') {
                    return '.myshopify.com';
                }
                if (this.model.hosted_server === 'WPE') {
                    return '.wpengine.com';
                }
                if (this.model.hosted_server === 'wix') {
                    return 'myworkmywix.wixsite.com/';
                }
                return this.demo_domain;
            },
            isWPE() {
                return this.model.hosted_server === 'WPE';
            },
            isWix() {
                return this.model.hosted_server === 'wix';
            },
            isWHM() {
                return (this.model.hosted_server !== 'WPE' && this.model.hosted_server !== 'shopify' && this.model.hosted_server !== 'wix');
            },
            servers() {
                if(typeof window['servers'] !== 'undefined') {
                    return window.servers;
                    return JSON.parse(window.servers);
                }
                return ['N/A'];
            }           
        },
        methods: {

            myisEmpty(ftp_list) {
                if( ftp_list.constructor === Object) {
                    return Object.keys(ftp_list).length !== 0;
                }
                return ftp_list.length;
            },
            openWPR() {
                window.location.href = '/remote?site=' + this.model.wpr_id;
            },
            resetApiKey() {
                this.wprProcessing = true;
                this.getNonce(this.getAPIkey);
            },
            findWPR() {
                if (!this.model.is_live) {
                    swal('The website needs to be live before adding WP Remote');
                    return;
                }
                this.axios.post('/api/website/find-wpr', {
                    domain: this.model.domain
                }).then((response) => {
                    this.model.wpr_id = response.data['ID'];
                    this.linkWPRsite(response.data['api_key']);
                }).catch((errors) => {
                    this.doWPRerror(errors);
                });
            },
            doAction(data) {
                let postData = {};
                if (typeof data === 'string') {
                    postData = {
                        doAction: data,
                        website_id: this.model.public_id,
                    };
                } else if (typeof data === 'object') {
                    postData = data;
                    postData.website_id = this.model.public_id;
                } else {
                    myAlert({ error: 'Bad Button. Please contact us.' });
                    return;
                }

                this.axios.post('/api/website/action', postData).then(function (response) {
                    if (typeof response.data !== 'undefined' && typeof response.data.success !== 'undefined') {
                        myAlert({success: response.data.success});
                    } else if (typeof response.data !== 'undefined' && typeof response.data.error !== 'undefined') {
                        myAlert(response.data.error);
                    } else {
                        myAlert({ success: 'Action initiated' })
                    }
                }).catch(() => {
                    myAlert('There was an error with that request.');
                });
            },
            createWPR() {
                if (!this.model.is_live) {
                    swal('The website needs to be live before adding WP Remote');
                    return;
                }
                this.wprProcessing = true;
                this.axios.post('/api/website/install-wpr', {
                    website_id: this.model.public_id
                }).then((response) => {
                    this.getNonce(this.addToWPR);
                }).catch((errors) => {
                    this.doWPRerror(errors);
                });
            },
            addToWPR(){
                let params = new URLSearchParams();
                params.append('nicename', this.model.site_name);
                params.append('company_id', this.model.company.id);
                params.append('domain', this.model.domain);
                params.append('group', 'Ungrouped');
                params.append('_nonce', this.nonce);
                this.axios.post('/wpremote/api/json/site', params).then((res) => {
                    if (typeof res.data['ID'] !== 'undefined') {
                        this.model.wpr_id = res.data['ID'];
                        this.linkWPRsite(res.data['api_key']);
                    }
                }).catch((errors) => {
                    if (errors.response.status === 400) {
                        this.findWPR();
                        return;
                    }
                    this.doWPRerror(errors);
                });
            },
            getNonce(callback) {
                this.axios.get('/wpremote/api/json/account/maekit/nonce').then((response) => {
                    this.nonce = response.data;
                    callback();
                }).catch((errors) => {
                    this.doWPRerror(errors);
                });
            },
            getAPIkey() {
                let params = new URLSearchParams();
                params.append('_nonce', this.nonce);
                this.axios.get('/wpremote/api/json/site/' + this.model.wpr_id + '/api-key', {
                    params: params
                }).then((res) => {
                    this.linkWPRsite(res.data);
                }).catch((errors) => {
                    this.doWPRerror(errors);
                });
            },
            linkWPRsite(api_key) {
                this.axios.post('/api/website/add-wpr-key', {
                    website_id: this.model.public_id,
                    wpr_id: this.model.wpr_id,
                    api_key: api_key
                }).then((info) => {
                    myAlert({ success: 'Successfully added site to WP Remote'});
                    this.wprProcessing = false;
                }).catch((errors) => {
                    this.doWPRerror(errors);
                });
            },
            doWPRerror(errors) {
                this.wprProcessing = false;
                fyi(errors);
                myAlert('Sorry there was an error');
            },
            enableSSL() {
                this.enablingSSL = true;
                this.axios.post('/api/website/enable-ssl', {
                    website_id: this.model.public_id
                }).then((response) => {
                    this.enablingSSL = false;
                    myAlert(response.data)
                }).catch((error) => {
                    this.enablingSSL = false;
                    myAlert(false);
                    fyi(error);
                    fyi(error.response);
                });
            },
            changeHttp() {
                this.enablingHttps = true;
                this.axios.post('/api/website/change-http', {
                    website_id: this.model.public_id
                }).then((response) => {
                    this.enablingHttps = false;
                    myAlert(response.data)
                }).catch((error) => {
                    this.enablingHttps = false;
                    myAlert(false);
                    fyi(error);
                    fyi(error.response);
                });
            },
            addFtp: function (id) {
                var vm = this;
                var data = '';
                Swal.fire({
                    title: 'Create FTP Account',
                    confirmButtonText: '<i class="icon icon-spinner fa-spin"></i> Create FTP',
                    input: 'text',
                    preConfirm: function (text) {
                        return new Promise(function (resolve, reject) {
                            setTimeout(function () {
                                vm.axios.post('/api/website/action', {
                                    doAction: 'create_ftp',
                                    website_id: vm.model.public_id,
                                    user: text,
                                }).then(function (response) {
                                    data = response.data;
                                    resolve(data.success);
                                });
                            }, 2000)
                        })
                    },
                    allowOutsideClick: false
                }).then(function (message) {
                    Swal.fire({
                        type: 'success',
                        title: 'FTP Account Created!',
                        html: message
                    })
                })
            },
            editFtp: function (user) {
                this.axios.post('/api/website/action', {
                    doAction: 'update_ftp',
                    website_id: this.model.public_id,
                    user: user,
                }).then(function (response) {
                    var data = response.data;
                    swal(
                        'Password updated!',
                        data.success,
                        'success'
                    )
                });
            },
            showModal() {
                $('#request_domain').modal('show');
            },
            hideModal() {
                $('#request_domain').modal('hide');
            },
            toggleLive() {
                this.model.is_live = (this.model.is_live == 1) ? 0 : 1;
                this.model.loader = true;
                this.model.modal = '#request_domain';
                this.$store('/api/website/store', this);
            },
            store() {
                this.model.modal = false;
                this.model.loader = true;
                this.$store('/api/website/store', this);
            },
            deleteTask() {
                this.$root.toggleLoader(true);
                this.axios.post('/api/website/delete-task', {
                    website_id: this.model.public_id
                }).then((response) => {
                    this.$root.toggleLoader(false);
                    if (typeof response.data['success'] !== 'undefined') {
                        myAlert({success: 'Website delete task has been created.'});
                        return;
                    }
                    myAlert('Sorry, there was an unspecified error.')
                }).catch((errors) => {
                    this.$root.toggleLoader(false);
                    myAlert('Sorry, there was an unspecified error.')
                });
            },
            suspend() {
                this.$root.toggleLoader(true);
                this.axios.post('/api/website/suspend', {
                    website_id: this.model.public_id
                }).then((response) => {
                    this.$root.toggleLoader(false);
                    if (typeof response.data['success'] !== 'undefined') {
                        myAlert({success: 'Website has been suspended via Cloudflare page rules.'});
                        return;
                    }
                    myAlert('Sorry, there was an unspecified error.')
                }).catch((errors) => {
                    this.$root.toggleLoader(false);
                    myAlert('Zone does not exist in our Cloudflare account.')
                });
            },
            /**
             * Unsuspend website
             * TODO : move to actions and refactor.
             */
            unsuspend() {
                this.$root.toggleLoader(true);
                this.axios.post('/api/website/unsuspend', {
                    website_id: this.model.public_id
                }).then((response) => {
                    this.$root.toggleLoader(false);
                    if (typeof response.data['success'] !== 'undefined') {
                        myAlert({success: 'The website has been unsuspended.'});
                        return;
                    }
                    myAlert('Sorry, there was an unspecified error.')
                }).catch((errors) => {
                    this.$root.toggleLoader(false);
                    myAlert('Sorry, there was an unspecified error.')
                });
            },
            setWebsite(data) {
                this.model = this.$setData(data, this.model);
                this.axios.get('/api/website/' + this.model.public_id + '/ftp-list').then((response) => {
                    let data = response.data;
                    if (typeof data['ftp_list'] !== 'undefined') {
                        this.ftp_list = data.ftp_list;
                    } else if(typeof data['error'] !== 'undefined') {
                        this.ftp_list_error = data.error;
                    }
                }).catch((errors) => {
                    fyi(errors);
                });
                //check suspended
                this.axios.get('/api/website/' + this.model.public_id + '/is-suspended').then((response) => {
                    let data = response.data;
                    this.model.isSuspended = data;
                }).catch((errors) => {
                    fyi(errors);
                });
            },
            href(link) {
                return '/website/' + this.model.public_id + link
            },
        },
        // It's good to clean up event listeners before a component is destroyed.
        beforeDestroy () {
            this.$eventHub.$off('websiteAction', this.doAction);
            this.$eventHub.$off('websiteSubmit', this.store);
            this.$eventHub.$off('setWebsite', this.setWebsite);
        }
    }
</script>
<style scoped>
    .i-info {
        padding: 10px 0 0;
    }
</style>